module.exports = __webpack_public_path__ + "img/reju7.428527af.png";